export const getStateByStateCode = (stateCode, suffix = '') => {
  if (!stateCode) return '';

  switch (stateCode) {
    case 'AZ':
      return `arizona${suffix}`;
    case 'NM':
      return `newMexico${suffix}`;
    default:
      return `nevada${suffix}`;
  }
};
